module.exports = __webpack_public_path__ + "static/img/team5.34c9c94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team5.png
// module id = fXMp
// module chunks = 1